import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import * as React from 'react';

/** Access the Shell framework context (telemetryClient, httpClient, authClient, etc.). */
export function useAppContext(): IEmployeeExperienceContext {
    return React.useContext(Context as React.Context<IEmployeeExperienceContext>);
}
